export const OWNERS_HUB_ROUTES = {
  HOME: '/',

  LOGIN: '/login',
  REGISTER: '/register',
  // SSO: Telegram OIDC code-flow lands here; the email-verification link lands on VERIFY_EMAIL.
  TELEGRAM_CALLBACK: '/telegram-callback',
  VERIFY_EMAIL: '/verify-email',

  CONFIGURATOR: '/configurator-v2',
  // The full pre-payment setup wizard (`v3`, folder `configurator-v3`). PARKED: its code stays,
  // but `/setup` only redirects to CONFIGURATOR_V0 (`ParkedSetupRedirect` in `src/routes.tsx`).
  CONFIGURATOR_V3: '/setup',
  // `v0`, the short pre-payment flow (Theme → Colors & Art Style → Payment review → Payment),
  // mounted at `/easy-setup`. Every owner is funnelled through it; see `src/utils/configurator-flow.ts`.
  CONFIGURATOR_V0: '/easy-setup',
  CONFIGURATOR_PAYMENT_SUCCESSFUL: '/configurator/payment-successful',

  STUDIO_HOME: '/account/home',
  // The POST-payment onboarding wizard (the "customizer" / deploy flow, mounted at
  // CUSTOMIZER_BASE). Renamed from `/account/configurator-v3` to `/account/onboarding`
  // to disambiguate it from the pre-payment `/setup` wizard, and pointed
  // straight at the real mounted route (it used to read `/account/configurator`,
  // which nothing mounted in-repo — see post-auth-route).
  STUDIO_CONFIGURATOR: '/account/onboarding',
};
